<template>
  <div :class="['legacy-alert', 'legacy-alert--' + tone]">
    <div class="legacy-alert__content">
      <svg
        v-if="!isSolid"
        class="legacy-alert__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>

      <div class="legacy-alert__message">
        <slot />
      </div>
    </div>

    <div v-if="$slots.cta" class="legacy-alert__actions">
      <slot name="cta" />
    </div>

    <button
      v-if="dismissible"
      type="button"
      class="legacy-alert__dismiss"
      :aria-label="dismissLabel"
      @click="$emit('dismiss', $event)"
    >
      <svg
        class="legacy-alert__dismiss-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LegacyAlert',
  props: {
    tone: {
      type: String,
      default: 'solid',
      validator: value => ['solid', 'tint'].indexOf(value) !== -1,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    dismissLabel: {
      type: String,
      default: 'Dismiss',
    },
  },
  computed: {
    isSolid() {
      return this.tone === 'solid';
    },
  },
};
</script>

<style scoped>
.legacy-alert {
  container-type: inline-size;
  container-name: legacy-alert;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  column-gap: 0.75rem;
  row-gap: 0.5rem;
  border: 0;
  padding: 0.5rem 3rem 0.5rem 1rem;
}

.legacy-alert--solid {
  background-color: #5A4CD5;
  color: #fff;
}

.legacy-alert--tint {
  background-color: #DBD6FF;
  color: #1B173F;
}

.legacy-alert__content {
  display: flex;
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100%;
  align-items: center;
  gap: 0.75rem;
}

/* Qualified by the parent on purpose. vue-loader's scoped transform does not add
   the data-v attribute to selectors inside @container, so a bare
   .legacy-alert__content here is specificity (0,1,0) and loses to the scoped base
   rule above at (0,2,0) — the query matches but never applies, and the CTA wraps
   onto its own line. Naming the parent restores (0,2,0); the later source
   position wins the tie. */
@container legacy-alert (min-width: 42rem) {
  .legacy-alert .legacy-alert__content {
    flex-basis: 0;
  }
}

.legacy-alert__actions {
  margin-left: auto;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.legacy-alert__message {
  margin: 0;
  min-width: 0;
  font-size: 1rem;
  line-height: 1.5;
}

.legacy-alert__icon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.legacy-alert__dismiss {
  position: absolute;
  right: 0.75rem;
  top: 0.5rem;
  bottom: 0.5rem;
  box-sizing: border-box;
  margin: 0;
  display: flex;
  max-height: 2rem;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border: 0;
  background-color: transparent;
  padding: 0;
  line-height: 1;
  /* Both tones colour the dismiss the same as their own text. */
  color: inherit;
}

.legacy-alert__dismiss:hover {
  opacity: 0.8;
}

/* autoprefixer 9.6.4 cannot parse @supports selector(), so :focus:not(:focus-visible)
   provides the same fallback: a browser without :focus-visible drops it as invalid
   and keeps the ring on every focus. */
.legacy-alert__dismiss:focus {
  outline: none;
  box-shadow: 0 0 0 2px currentColor;
}

.legacy-alert__dismiss:focus:not(:focus-visible) {
  box-shadow: none;
}

.legacy-alert__dismiss-icon {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
